import React from 'react'

import PropTypes from 'prop-types'

import messages from './messages'

/**
 *  Arranges two list items that enclose icon-like and text elements of opposing semantics
 *  in response to an onClick param. The classNames defined in `StyledNavWrapperWithDropDown` 
 *  control their !not visibility.
 * @see StyledNavWrapperWithDropDown
 * @param {{
 *  toggleMoreDropdown: () => (value: React.SetStateAction<boolean>) => void,
 *  language: string,
 * }}
 * @return {React.ReactNode}
 */
const DeviceCategoriesToggle = ({ toggleMoreDropdown, language }) => {
  const translated = messages[language]

  return (
    <>
      <li className="menu-toggle menu-close">
        <a onClick={() => toggleMoreDropdown()}>
          <span>&#215;</span>
          <span>{translated.close}</span>
        </a>
      </li>
      <li className="menu-toggle menu-open">
        <a onClick={() => toggleMoreDropdown()}>
          <span>&#9776;</span>
          <span>{translated.more}</span>
        </a>
      </li>
    </>
  )
}

DeviceCategoriesToggle.propTypes = {
  language: PropTypes.string.isRequired,
  toggleMoreDropdown: PropTypes.func.isRequired
}

export default DeviceCategoriesToggle



// WEBPACK FOOTER //
// ./src/components/SubHeader/DeviceCategoriesToggle.js